import { v4 as uuid } from 'uuid';
import SubBlockTextData from './SubBlockTextData';

class BlockTextListColumnData {
  id: string;
  data?: SubBlockTextData[];
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTextListColumnData {
  export function make(data: SubBlockTextData[]): BlockTextListColumnData {
    return {
      id: uuid(),
      data,
    };
  }

  export function getDefault(): BlockTextListColumnData {
    return make(
      [
        SubBlockTextData.getDefault(),
        SubBlockTextData.getDefault(),
        SubBlockTextData.getDefault(),
      ],
    );
  }
}

export default BlockTextListColumnData;
